import { Asset } from 'expo-asset'
import * as Sharing from 'expo-sharing'
import { ShareAppScreenProps } from 'home/stack/types'
import { t } from 'app/i18l'
import React, { useCallback } from 'react'
import { errorAlert } from 'shared/alerts'
import { ShareAppView } from './view'

interface Media {
  url: string
  id: string
}

export function ShareAppScreen({}: ShareAppScreenProps) {
  const onShare = useCallback(async () => {
    const fileDetails = {
      extension: '.jpg',
      shareOptions: {
        mimeType: 'image/jpeg',
        dialogTitle: 'Share NEXT!',
        UTI: 'image/jpeg',
      },
    }
    const [{ localUri }] = await Asset.loadAsync(
      require('assets/share_app/share-app.jpg')
    )

    if (!(await Sharing.isAvailableAsync())) {
      errorAlert(
        {
          message: t('sharingErrorMessage'),
          name: t('sharingErrorName'),
        },
        t('sharingNotAvailable')
      )
      return
    }
    await Sharing.shareAsync(localUri ?? '', fileDetails.shareOptions)
  }, [])

  return <ShareAppView onShare={onShare} />
}
